import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { observer } from "mobx-react";

const panelVariants = cva("border border-border", {
  variants: {
    size: {
      sm: "rounded-lg p-3",
      md: "rounded-xl p-4",
      lg: "rounded-xl p-5",
    },
    tone: {
      default: "bg-background",
      card: "bg-card",
      muted: "bg-muted/30",
      plain: "",
    },
  },
  defaultVariants: {
    size: "lg",
    tone: "card",
  },
});

const Panel = observer(
  React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof panelVariants>
    // eslint-disable-next-line mobx/missing-observer -- outer observer() wraps the forwardRef
  >(function Panel({ className, size, tone, ...props }, ref) {
    return (
      <div
        ref={ref}
        data-slot="panel"
        className={cn(panelVariants({ size, tone }), className)}
        {...props}
      />
    );
  }),
);

Panel.displayName = "Panel";

export { Panel };
